// apps/provider/src/utils/formAlerts.js
// Display helpers for persisted form answer alerts (patient_alert rows stamped
// onto appointments as `form_alerts` by the calendar / Home enrichment).

const SEVERITY_RANK = { red: 3, amber: 2, blue: 1 };

/** Highest severity across a list of alerts; 'amber' when the list is empty or unknown. */
export function highestFormAlertSeverity(alerts) {
  let best = null;
  for (const a of alerts || []) {
    const s = a?.severity;
    if (SEVERITY_RANK[s] && (!best || SEVERITY_RANK[s] > SEVERITY_RANK[best])) best = s;
  }
  return best || 'amber';
}

// Solid badge fill (EventCard / legend)
export const FORM_ALERT_BADGE_BG = {
  red: 'bg-red-500',
  amber: 'bg-amber-400',
  blue: 'bg-blue-500',
};

// Soft chip (hover popup, phone sheet, Home rows)
export const FORM_ALERT_CHIP_CLASS = {
  red: 'text-red-700 bg-red-50',
  amber: 'text-amber-700 bg-amber-50',
  blue: 'text-blue-700 bg-blue-50',
};

/** Tooltip text: one line per alert title. */
export function formAlertsTitle(alerts) {
  return (alerts || []).map(a => a?.title).filter(Boolean).join('\n') || 'Form alert';
}
